import {} from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { IMenu } from '../utils/IMenu';
import { MainService } from './main.service';
import { MatDialog } from '@angular/material/dialog';
import { GenericValidateComponent } from '../generic-components/generic-validate/generic-validate.component';
import { GenericToastrService } from '../generic-components/generic-toastr/generic-toastr.service';
import { NgxSpinner, NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    RouterModule,
    MatMenuModule,
    RouterModule,
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.css',
})
export class MainComponent implements OnInit {
  menus: IMenu[] = [];

  environnement: string = "";

  modeSidenav: MatDrawerMode = 'side';
  openedSidenav: boolean = true;

  firstNameUser: string = '';
  lastNameUSer: string = '';

  constructor(
    private mainService: MainService,
    private router: Router,
    private dialog: MatDialog,
    private toastr: GenericToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.menus = this.mainService.getMenus();

    this.firstNameUser = JSON.parse(
      localStorage.getItem('user') ?? '""'
    ).firstName;
    this.lastNameUSer = JSON.parse(localStorage.getItem('user') ?? '""').name;

    const hostname = window.location.hostname;

    if(hostname === "localhost"){
      this.environnement = "DEV";
    } else if (hostname === 'abopi-int.partner-informatique.fr') {
      this.environnement = 'INT';
    }
  }

  backToLogin() {
    localStorage.clear();
    this.router.navigate(['']);
  }

  syncroClicked() {
    const dialogRef = this.dialog.open(GenericValidateComponent, {
      data: {
        libelle:
          "Voulez-vous vraiment lancer une syncro ? (Durée moyenne d'une syncro : ~30min)",
      },
      width: '50%',
      backdropClass: 'blurred-backdrop',
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result === true) {
          this.spinner.show();
          this.mainService.createSyncro().subscribe(
            (result) => {
              console.log('Syncro terminé');
            },
            (error) => {
              this.toastr.openSnackBarProblem(error.error.message);
            }
          );
          this.spinner.hide();

          this.toastr.openSnackBarSuccess("Syncro en cours d'exécution...");
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  pointagebuttonClicked(){
    window.location.href = environment.pointage
  }
}
